import type React from 'react';

export const DownArrow: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 192 32.4"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <polygon points="192,0.3 96,32.3 0,0.3 96,15.3" />
    </g>
  </svg>
);

export default DownArrow;
